import { createService } from "~/hocs/crud";
import * as model from "./model";

const getDefinedLegendGuid = (record) => {
    return {
        ownerDefinedLegendGuid: record.ownerDefinedLegendGuid,
    };
};

export const MODEL_NAME = "definedLegendSetup";
export const REQUEST_PAYLOAD_FILTER = "definedLegendFilter";
export const REQUEST_PAYLOAD_SORT_LIST = "definedLegendSortList";
export const REQUEST_PAYLOAD_PAGE_OPTIONS = "definedLegendPageOptions";

export const defaultRequestFilters = {
    [REQUEST_PAYLOAD_FILTER]: {
        layerTypeName: "",
        attributeName: "",
        cropName: "",
        cropPurposeName: "",
        productName: "",
        location: "",
    },
    [REQUEST_PAYLOAD_SORT_LIST]: [
        {
            Sort: {
                Direction: "ASC",
                Order: 0,
            },
        },
    ],
    [REQUEST_PAYLOAD_PAGE_OPTIONS]: {
        pageSize: 50,
        skip: 0,
    },
};

export const defaultSort = {
    FieldName: "LayerTypeName",
    ...defaultRequestFilters[REQUEST_PAYLOAD_SORT_LIST][0],
};

export const service = createService({
    guid: model.PROPS_DEFINED_LEGEND_GUID,
    id: model.PROPS_DEFINED_LEGEND,
    recordName: "ownerDefinedLegendGuid",
    model: MODEL_NAME,
    defaultRequestFilters,
    REQUEST_PAYLOAD_FILTER,
    REQUEST_PAYLOAD_SORT_LIST,
    REQUEST_PAYLOAD_PAGE_OPTIONS,
    _defaultLabels: {
        [model.PROPS_CAN_DELETE]: {
            visible: false,
            label: "canDelete",
            gridCol: 5,
            className: "col-shift-15",
        },
        [model.PROPS_LAYER_TYPE_NAME]: {
            label: "layerType",
            gridCol: 15,
        },
        [model.PROPS_LOCATION]: {
            label: "location",
            gridCol: 25,
        },
        [model.PROPS_ATTRIBUTE_NAME]: {
            label: "attributeName",
            gridCol: 15,
        },
        [model.PROPS_CROP_NAME]: {
            label: "crop",
            gridCol: 15,
        },
        [model.PROPS_DL_CROP_PURPOSE_NAME]: {
            label: "cropPurposeName",
            gridCol: 15,
        },
        [model.PROPS_DL_PRODUCT_NAME]: {
            label: "productName",
            gridCol: 15,
        },
    },
    getGuid: getDefinedLegendGuid,
    defaultSort: {
        FieldName: "LayerTypeName",
        Sort: {
            Direction: "ASC",
            Order: 0,
        },
    },
});
